import React from 'react';
import { motion } from 'framer-motion';

const Solution = () => {
  return (
    <section id="solution" className="py-20 bg-gradient-to-br from-blue-900/20 to-purple-900/20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-8">
            A revenue asset, not just a website
          </h2>
          
          <div className="space-y-6 text-lg text-white/80">
            <p>
              This isn't another generic website template. It's a single focused page engineered to convert visitors into paying customers.
            </p>
            
            <p>
              Built for local search and mobile calls, designed around customer trust, with one clear goal: generating enquiries for your trade business.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mt-12">
            {[
              {
                title: 'Trust-First Structure',
                description: 'Removes doubt and builds credibility instantly'
              },
              {
                title: 'Local SEO Foundations', 
                description: 'Ranks in your service area from day one'
              },
              {
                title: 'Mobile Conversion Paths',
                description: 'Designed for how customers actually browse and call'
              }
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-6"
              >
                <h3 className="text-white font-semibold mb-3">{item.title}</h3>
                <p className="text-white/70">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Solution;